module.exports = __webpack_public_path__ + "img/galleria14.cff59f03.jpg";